module.exports = __webpack_public_path__ + "media/images/icons/nodata-63b5e2c6a0b73959922d6e7ee32f646c.svg";